import { NotificationUI } from 'features/notifications'
import AccountPage from 'pages/account'
import { ActivityPage } from 'pages/activityQueue'
import ArchiveCampaignsPage from 'pages/archiveCampaigns'
import { CampaignsCreatePage } from 'pages/campaignCreate'
import { CampaignsHubspotPage } from 'pages/campaignHubspot'
import CampaignsPage from 'pages/campaigns'
import ContactsPage from 'pages/contacts'
import { MailboxPage } from 'pages/Mailbox'
import { MessagingPage } from 'pages/MessagingPage'
import NotfoundPage from 'pages/notfound'
import SingleCampaignPage from 'pages/singleCampaign'
import SingleContactsPage from 'pages/singleContacts'
import { InvitedPage } from 'pages/team/invitations'
import { MembersPage } from 'pages/team/members/MembersPage'
import { StatisticsPage } from 'pages/team/statistics'
import { UpgradePage } from 'pages/upgrade/UpgradePage'
import {
	Redirect,
	Route,
	BrowserRouter as Router,
	Switch
} from 'react-router-dom'
import { useAppSelector } from 'shared/hooks'

import { appSelectors } from '../../redux/reducers/app'
import { AuthCallback } from './AuthCallback'
import ErrorBoundary from './ErrorBoundary'
import { useListeners } from './hooks/useListeners'
import { useTrackingUser } from './hooks/useTrackingUser'
import InvitationCallback from './InvitationCallback'

// Styles
import '@fontsource-variable/open-sans'
import 'semantic-ui-css/semantic.min.css' // TODO: Bad reset, delete in future
import 'reset-css'

import './style.scss'
import '../../assets/main.scss'
import LayoutUser from './LayoutUser'
import { ReferrerPage } from './ReferrerPage'

export function App() {
	useListeners()
	const isUpgraded = useAppSelector(appSelectors.isUpgraded)
	useTrackingUser()

	return (
		<ErrorBoundary>
			<Router>
				<Switch>
					<LayoutUser component={CampaignsPage} exact path='/campaigns' />
					<Route exact path='/'>
						<Redirect to='/campaigns' />
					</Route>

					{isUpgraded ? (
						<Route exact path='/upgrade'>
							<Redirect to='/campaigns' />
						</Route>
					) : (
						<LayoutUser component={UpgradePage} exact path='/upgrade' />
					)}
					<LayoutUser component={ActivityPage} exact path='/activities-queue' />
					<LayoutUser component={ArchiveCampaignsPage} exact path='/archive' />
					<LayoutUser
						archive
						component={SingleCampaignPage}
						exact
						path='/archive/:id'
					/>

					<LayoutUser
						component={SingleCampaignPage}
						exact
						path='/campaigns/:id'
					/>

					<LayoutUser
						component={CampaignsCreatePage}
						exact
						path='/campaigns/:id/tune'
					/>

					<LayoutUser
						component={CampaignsHubspotPage}
						exact
						path='/campaigns/:id/hubspot'
					/>

					<LayoutUser
						component={SingleContactsPage}
						exact
						path='/campaigns/:id/contacts'
					/>

					<LayoutUser component={ContactsPage} exact path='/contacts' />
					<LayoutUser component={MembersPage} exact path='/team/members' />

					<LayoutUser
						component={StatisticsPage}
						exact
						path='/team/statistics'
					/>

					<LayoutUser component={InvitedPage} exact path='/team/invitations' />

					<LayoutUser
						component={ContactsPage}
						exact
						path='/contacts/import/:id'
					/>

					<LayoutUser component={AccountPage} exact path='/account' />
					<Route component={AuthCallback} exact path='/auth_callback' />
					<Route
						component={InvitationCallback}
						exact
						path='/invitation_callback'
					/>
					<Route component={ReferrerPage} exact path='/referrer/:id' />

					<LayoutUser component={MessagingPage} exact path={'/messaging'} />
					<LayoutUser
						component={MessagingPage}
						exact
						path={'/messaging/thread/:conversation'}
					/>

					<Route exact path={'/mailbox'}>
						<Redirect to={'/messaging'} />
					</Route>

					<Route exact path={'/mailbox/thread/:conversation'}>
						<MailboxPage />
					</Route>

					<LayoutUser component={NotfoundPage} />
				</Switch>
			</Router>

			<NotificationUI.Snackbar />
		</ErrorBoundary>
	)
}
